export const getModuleMessages = async (locale: ApplicationLocale) => import(`@/modules/overview/locales/${locale}.json`);

export default getModuleMessages;
